import axios from 'axios'
import config from '../config/config'
import { Message, MessageBox } from 'element-ui'

// import store from '../store'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.BASE_API, // api的base_url
  timeout: 15000, // 请求超时时间
})
axios.defaults.withCredentials=true;

// request拦截器
service.interceptors.request.use((cfg) => {
  cfg.headers['X-Authorization'] = 'token:cy4fgbil24jucmh8jfr5'
  return cfg
}, (error) => {
  // Do something with request error
  // console.log(error) // for debug
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  (response) => {
    const res = response.data

    if (res.rc === 0 || res.code === 20000 || res.status === 'ok') {
      return res
    }
    // Message({
    //   message: res.data,
    //   type: 'error',
    //   duration: 5 * 1000,
    // })

    // 50008:非法的token; 50012:其他客户端登录了;  50014:Token 过期了;
    if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
      MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
        confirmButtonText: '重新登录',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        // store.dispatch('FedLogOut').then(() => {
        //   location.reload()// 为了重新实例化vue-router对象 避免bug
        // })
      })
    }
    return res
  },
  (error) => {
    console.log(error)// for debug
    Message({
      message: config.NETWORK_ERROR_MSG,
      type: 'error',
      duration: 5 * 1000,
    })
    return Promise.reject(error)
  },
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js